import { 
  Modal, 
  Box, 
  Typography, 
  Grid, 
  Button, 
  TextField,
} from "@mui/material";
import { FileUploadArea } from "../../../../components/BaseInputs/UploadDragDrop";

interface CertificadoModalProps {
  openCertificadoModal: boolean;
  handleCloseModal: () => void;
  certificadoData: any;
  handleFileUpload: (file: File, key: 'publicKey' | 'privateKey') => void;
  handlePasswordChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleSubmitCertificado: () => void;
  handleRemoveFile: (key: 'publicKey' | 'privateKey') => void;
}

export function CertificadoModal({
  openCertificadoModal, 
  handleCloseModal, 
  handleRemoveFile,
  certificadoData, 
  handleFileUpload, 
  handlePasswordChange, 
  handleSubmitCertificado
}: CertificadoModalProps) {


  const handleModalDragOver = (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleModalDrop = (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleModalDragLeave = (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
  };
  return (
    <Modal
      open={openCertificadoModal}
      onClose={handleCloseModal}
      aria-labelledby="certificado-digital-modal"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '90%', sm: 600 },
          maxWidth: '95vw',
          maxHeight: '90vh',
          overflow: 'auto',
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          borderRadius: 1
        }}
        onDragOver={handleModalDragOver}
        onDragLeave={handleModalDragLeave}
        onDrop={handleModalDrop}
      >
        <Typography variant="h5" component="h2" gutterBottom fontWeight="bold">
          Configurar Certificado Digital
        </Typography>
        

           <Grid container spacing={3}>
          <Grid size={{xs: 12}}>
            <FileUploadArea
              title="Chave Pública (.pem)"
              subtitle="Selecione o arquivo da chave pública do certificado"
              file={certificadoData.publicKey}
              error=""
              onFileSelect={(file) => handleFileUpload(file, 'publicKey')}
              acceptedFileTypes={['.pem']}
              maxFileSize={10 * 1024 * 1024}
              required
              onFileRemove={() => handleRemoveFile('publicKey')}
            />
          </Grid>

          <Grid size={{xs: 12}}>
            <FileUploadArea
              title="Chave Privada (.pem)"
              subtitle="Selecione o arquivo da chave privada do certificado"
              file={certificadoData.privateKey}
              error=""
              onFileSelect={(file) => handleFileUpload(file, 'privateKey')}
              acceptedFileTypes={['.pem']}
              maxFileSize={20 * 1024 * 1024}
              onFileRemove={() => handleRemoveFile('privateKey')}
              required
            />
          </Grid>
          <Grid size={{xs: 12}}>
            <TextField
              label="Senha do Certificado"
              type="password"
              required
              fullWidth
              value={certificadoData.password}
              onChange={handlePasswordChange}
              variant="outlined"
              error={false}
              helperText={""}
            />
          </Grid>

          <Grid size={{xs: 12}} sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end', mt: 2 }}>
            <Button
              variant="outlined"
              onClick={handleCloseModal}
              size="large"
            >
              Cancelar
            </Button>
            <Button
              variant="contained"
              onClick={handleSubmitCertificado}
              size="large"
              disabled={!certificadoData.publicKey || !certificadoData.privateKey || !certificadoData.password}
            >
              Salvar
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
}